import cx from 'classnames';
import PropTypes from 'prop-types';
import { UI_LOGO } from '@bwoty-web/ui-kit/icons';
import { useIsGlobetrotter } from '@bwoty-web/ui-kit/hooks';
import { useContext, useState } from 'react';
import {
  Carousel,
  Grid,
  GridItem,
  Icon,
  Modal,
  RoomCard,
} from '@bwoty-web/ui-kit';

import GlobalContext from '../../context/globalContext';
import CarouselSwitchButton from '../shared/carouselSwitchButton/CarouselSwitchButton';

import './cabinList.scss';

const CabinList = ({
  cabins,
  selectCabin,
  selectedCabin,
  isChangeCabinPage,
}) => {
  const { labels } = useContext(GlobalContext);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [readMoreCabin, setReadMoreCabin] = useState(null);
  const [showCardsInCarousel, setShowCardsInCarousel] = useState(true);
  const isGlobetrotter = useIsGlobetrotter();

  const toggleCardViewHandler = () =>
    setShowCardsInCarousel((prevState) => !prevState);

  const roomCardOnClickHandler = (isSoldOut, cabinKey) => {
    if (!isSoldOut) selectCabin(cabinKey);
  };

  const buildRoomCard = (cabin) => {
    const { totalPrice, description, images, key, cabinName } = cabin;
    const [largeImage] = images;
    const isSoldOut = !totalPrice;

    const roomCardContent = {
      columnSpan: 4,
      description,
      externalImage:
        !largeImage?.cloudinaryUriTemplate && isGlobetrotter ? (
          <div className="iw-cabin-list__default-room-image">
            <Icon path={UI_LOGO} size="xl" />
          </div>
        ) : undefined,
      image: { cloudinaryUriTemplate: largeImage?.cloudinaryUriTemplate },
      linkList: [
        {
          'aria-haspopup': 'dialog',
          onClick: () => {
            setReadMoreCabin(cabin);
            setModalIsOpen(true);
          },
          text: labels.readMoreRoom,
        },
      ],
      onClick: () => roomCardOnClickHandler(isSoldOut, key),
      price: parseInt(totalPrice?.replace(/\D+/g, ''), 10),
      title: cabinName,
    };

    if (isSoldOut) {
      roomCardContent.buttonText = labels.soldOut;
      roomCardContent.buttonDisabled = true;
    }

    if (key === selectedCabin.key) {
      roomCardContent.buttonText = labels.roomSelectedBtnLabel;
      roomCardContent.buttonVariant = 'primary';
    }

    if (showCardsInCarousel) roomCardContent.key = key;

    return (
      <RoomCard
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...roomCardContent}
      />
    );
  };

  const renderRoomCards = () =>
    cabins.map((cabin) =>
      showCardsInCarousel ? (
        buildRoomCard(cabin)
      ) : (
        <GridItem columnSpan={4} key={cabin.key}>
          {buildRoomCard(cabin)}
        </GridItem>
      ),
    );

  return (
    <>
      {cabins?.length > 0 && (
        <div
          className={cx('iw-cabin-list__header-container', {
            'iw-cabin-list__header-container--changeCabinPage':
              isChangeCabinPage,
          })}
        >
          {!isChangeCabinPage && (
            <h2 className="iw-cabin-list__subheading">
              {labels?.cabinListHeading}
            </h2>
          )}
          <CarouselSwitchButton
            label={labels.carouselSwitchButtonLabel}
            showCardsInCarousel={showCardsInCarousel}
            toggleCardView={toggleCardViewHandler}
          />
        </div>
      )}
      {showCardsInCarousel ? (
        <Carousel>{renderRoomCards()}</Carousel>
      ) : (
        <Grid>{renderRoomCards()}</Grid>
      )}
      <Modal
        heading={readMoreCabin?.cabinName}
        isOpen={modalIsOpen}
        onClose={() => {
          setModalIsOpen(false);
          setReadMoreCabin(null);
        }}
      >
        <p className="iw-cabin-list__modal-paragraph">
          {readMoreCabin?.description}
        </p>
      </Modal>
    </>
  );
};

CabinList.propTypes = {
  cabins: PropTypes.arrayOf(
    PropTypes.shape({
      cabinName: PropTypes.string,
      key: PropTypes.string,
    }),
  ).isRequired,
  selectCabin: PropTypes.func.isRequired,
  selectedCabin: PropTypes.shape({
    key: PropTypes.string,
  }).isRequired,
  isChangeCabinPage: PropTypes.bool.isRequired,
};

export default CabinList;
